import { render } from "./BundleBagOverlay.vue?vue&type=template&id=08b1d910"
import script from "./BundleBagOverlay.vue?vue&type=script&lang=js"
export * from "./BundleBagOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/bundle-builder/components/BundleBagOverlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08b1d910"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08b1d910', __exports__)) {
    api.reload('08b1d910', __exports__)
  }
  
  module.hot.accept("./BundleBagOverlay.vue?vue&type=template&id=08b1d910", () => {
    api.rerender('08b1d910', render)
  })

}


export default __exports__